/**
 * 模組頁面代碼 : 1420-UI-01
 * 頁面說明 : 派工管理資料清單列表頁面
 * @module modules/dispatch-management/components/DispatchManagementPage
 */

import React, {useState, useEffect, useRef, useMemo, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {BaseComponent} from 'web/components/BaseComponent';
import enumList from 'web/utils/enumList';
import {
  CASE_PRIORITY_HIGH,
  CASE_PRIORITY_NORMAL,
  FLG_CLOSE,
  FLG_OPEN,
} from 'web/constant';
import {useDispatchManagement} from '../hooks/useDispatchManagment';
import {showMessage} from 'web/utils/modalHelper';
import moment from 'moment';

const DispatchManagementPage = (props) => {
  const dispatch = useDispatch();
  const baseComponent = new BaseComponent(props);
  const tableRef = useRef(null);
  const formRef = useRef(null);
  // const today = new Date().toISOString().split('T')[0];
  const startTime = moment().startOf('day').format('YYYYMMDDHHmmss'); // 👉 20250417 00:00:00
  const endTime = moment().endOf('day').format('YYYYMMDDHHmmss'); // 👉 20250417 23:59:59
  const today = moment().endOf('day').format('YYYY-MM-DD');
  const {
    showModel,
    setSearchId,
    setCurrentStartTime,
    setCurrentEndTime,
    setPreviewAssignment,
    setEditOrderAssignment,
    isReload,
    isReloadDone,
  } = props;
  const {
    dispatchList,
    getDispatchList,
    handleSearch,
    // getEmployeeList,
    // employeeList,
  } = useDispatchManagement(showMessage, baseComponent);

  useEffect(() => {
    const handleClick = (event) => {
      const getCurrentAssignment = (button) => {
        const index = parseInt(button.id.split('-')[2]);
        return dispatchList.find((_, i) => i === index);
      };

      const button = event.target.closest('.btn');
      if (button && button.id.startsWith('edit-dispatch-')) {
        const assignmnet = getCurrentAssignment(button);
        setSearchId(assignmnet.assignmentId);
        setCurrentStartTime(assignmnet.workStartTime);
        setCurrentEndTime(assignmnet.workEndTime);
        showModel(true);
      }
      if (button && button.id.startsWith('preview-dispatch-')) {
        const assignment = getCurrentAssignment(button);
        setPreviewAssignment(JSON.parse(JSON.stringify(assignment)));
      }
      if (button && button.id.startsWith('order-dispatch-')) {
        const assignmnet = getCurrentAssignment(button);
        setEditOrderAssignment(JSON.parse(JSON.stringify(assignmnet)));
      }
    };

    if (tableRef.current) {
      tableRef.current.addEventListener('click', handleClick);
    }

    return () => {
      if (tableRef.current) {
        tableRef.current.removeEventListener('click', handleClick);
      }
    };
  }, [dispatchList]);

  useEffect(() => {
    baseComponent.checkPermission(
      enumList.moduleEnums.case,
      enumList.accessModeEnums.read,
    );
    getDispatchList(undefined, undefined, startTime, endTime);
  }, []);

  useEffect(() => {
    if (isReload) {
      formRef.current.requestSubmit();
      isReloadDone();
    }
  }, [isReload]);

  return (
    <section id="datatable-container">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <svg
              className="nav__icon nav__icon--breadcrumb me-3"
              aria-hidden="true"
            >
              <use href="#ico-home-line"></use>
            </svg>
            派工管理
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            派工管理
          </li>
        </ol>
      </nav>
      <h4>派工管理</h4>
      <div className="datatable__search">
        <form
          ref={formRef}
          className="d-flex gap-2 align-items-end needs-validation"
          noValidate
          onSubmit={handleSearch}
        >
          <div className="flex-fill w-100">
            <label htmlFor="searchCasePriority" className="form-label">
              等級
            </label>
            <select
              className="form-select form-select-sm"
              id="searchCasePriority"
              name="searchCasePriority"
              //   value={searchCasePriority}
              //   onChange={(e) => setSearchCasePriority(e.target.value)}
              required
            >
              <option disabled value="">
                請選擇
              </option>
              <option value="0">全部</option>
              <option value={enumList.casePriority.high}>
                {CASE_PRIORITY_HIGH}
              </option>
              <option value={enumList.casePriority.normal}>
                {CASE_PRIORITY_NORMAL}
              </option>
            </select>
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchDispatchEmployee" className="form-label">
              是否已派工
            </label>
            <select
              className="form-select form-select-sm"
              id="searchDispatchEmployee"
              name="searchDispatchEmployee"
              //   value={searchFlgStatus}
              //   onChange={(e) => setSearchFlgStatus(e.target.value)}
              required
            >
              <option disabled value="">
                請選擇
              </option>
              <option value="0">全部</option>
              <option value={enumList.caseFlgStatus.close}>{FLG_CLOSE}</option>
              <option value={enumList.caseFlgStatus.open}>{FLG_OPEN}</option>
            </select>
          </div>

          <div className="flex-fill w-100">
            <label htmlFor="searchStartDate" className="form-label">
              立案時間
            </label>
            <input
              type="date"
              className="form-control form-control-sm"
              id="searchStartDate"
              name="searchStartDate"
              defaultValue={today}
              //   value={searchStartDate}
              //   onChange={(e) => setSearchStartDate(e.target.value)}
            />
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchEndDate" className="form-label"></label>
            <input
              type="date"
              className="form-control form-control-sm"
              id="searchEndDate"
              name="searchEndDate"
              defaultValue={today}
              //   value={searchEndDate}
              //   onChange={(e) => setSearchEndDate(e.target.value)}
            />
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchSalesOrder" className="form-label">
              銷貨單號
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="searchSalesOrder"
              name="searchSalesOrder"
              //   value={searchEndDate}
              //   onChange={(e) => setSearchEndDate(e.target.value)}
            />
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchInvoice" className="form-label">
              發票號碼
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="searchInvoice"
              name="searchInvoice"
              //   value={searchEndDate}
              //   onChange={(e) => setSearchEndDate(e.target.value)}
            />
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchQuotationNo" className="form-label">
              報價單號
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="searchQuotationNo"
              name="searchQuotationNo"
              //   value={searchEndDate}
              //   onChange={(e) => setSearchEndDate(e.target.value)}
            />
          </div>
          <button className="btn btn-primary" type="submit">
            <svg className="btn__icon" aria-hidden="true">
              <use href="#ico-search"></use>
            </svg>
          </button>
        </form>
      </div>
      <div className="datatable__tool">
        {/* <div className="d-flex align-items-center gap-2">
          <div className="datatable__tool__label">
            多筆選擇
            <div id="checked-count-display"></div>
          </div>
          {baseComponent.checkPermission(enumList.moduleEnums.customer, enumList.accessModeEnums.delete) && (
            <div className="btn-group btn-group-sm" role="group" aria-label="">
              <button
                type="button"
                className="btn btn-outline-secondary btn-batch"
                id="btnBatchEnable"
                // onClick={() => onBatch(enumList.alertModalModeEnums.enable)}
              >
                啟用
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary btn-batch"
                id="btnBatchDisable"
                // onClick={() => onBatch(enumList.alertModalModeEnums.disable)}
              >
                停用
              </button>
            </div>
          )}
        </div> */}
      </div>
      <div className="datatable__data" ref={tableRef}>
        <table
          id="datatable__dispatch"
          className="display table table-hover align-middle nowrap"
        ></table>
      </div>
    </section>
  );
};

export default DispatchManagementPage;
